var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4292 63.2167L66.2667 54.3792L91.25 79.3625L82.4125 88.2L57.4292 63.2167ZM72.9167 41.6667C80.9583 41.6667 87.5 35.125 87.5 27.0833C87.5 24.6667 86.8333 22.4167 85.7917 20.4167L74.5417 31.6667L68.3333 25.4583L79.5833 14.2083C77.5833 13.1667 75.3333 12.5 72.9167 12.5C64.875 12.5 58.3333 19.0417 58.3333 27.0833C58.3333 28.7917 58.6667 30.4167 59.2083 31.9167L51.5 39.625L44.0833 32.2083L47.0417 29.25L41.1667 23.375L50 14.5417C47.6562 12.2008 44.4792 10.886 41.1667 10.886C37.8542 10.886 34.6771 12.2008 32.3333 14.5417L17.5833 29.2917L23.4583 35.1667H11.7083L8.75 38.125L23.5 52.875L26.4583 49.9166V38.125L32.3333 44L35.2917 41.0417L42.7083 48.4583L11.8333 79.3333L20.6667 88.1666L68.0833 40.7917C69.5833 41.3333 71.2083 41.6667 72.9167 41.6667Z",
    fill: "#091E5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.2b3653cd885ba3e11d66678b78716a43.svg";
export { ForwardRef as ReactComponent };